import generatePayload from '@gov.wa.lni/application.isolated-workers-complaint/source/data/generatePayload.js';

export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const setAttribute = function(context, id, attribute, value) {
        context.commit('setAttribute', {
            id,
            attribute,
            value,
        }, {
            root: true,
        });
    };
    const setIsLoading = function(context, value) {
        context.commit('appState/SET_VALUE', {
            key: 'isLoading',
            value,
        }, {
            root: true,
        });
    };

    if (context.rootState[`${moduleId}_errors`].errors.length) {
        return;
    }

    setAttribute(context, moduleId, 'load', true);
    setIsLoading(context, true);
    const responseData = generatePayload(context);

    const config = payload.oneLni.environment.current.alisService;
    const endpoint = `${config.domain}/ALiSService/api/Complaint/SaveComplaint`;
    fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            // eslint-disable-next-line camelcase
            api_key: config.apiKey,
        },
        body: JSON.stringify(responseData),
    }).then(response => response.json()).then(result => {
        if (result.ComplaintNumber) {
            context.commit('appState/SET_VALUE', {
                key: 'userData',
                value: result.ComplaintNumber,
            }, {
                root: true,
            });
            context.commit('appState/SET_VALUE', {
                key: 'complaintNumber',
                value: result.ComplaintNumber,
            }, {
                root: true,
            });
            payload.router.push('/confirmation');
        } else if (result.ErrorList) {
            setAttribute(
                context,
                `${moduleId}_post-submission-errors`,
                'items',
                Object.keys(result.ErrorList).map(key => ({
                    level: 'Error',
                    message: result.ErrorList[key],
                })),
            );
            setIsLoading(context, false);
        }
    }).catch(() => {
        setAttribute(context, moduleId, 'displayFormError', true);
        setIsLoading(context, false);
    });
};